import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { TrophyState } from "./TrophyState";

export class TrophyIconsContainer extends Phaser.Group {

    private static PX_ICONS = [
        640,
        560,
        485,
        410,
        345,
        260,
        165,
        70,
        0
    ];

    private initialTrophies: Phaser.Sprite[];
    private initTrophiesIndex: number;

    constructor(game: Phaser.Game) {

        super(game, null, "trophy-icons-container", false);
    }

    public initIntroConfiguration(): void {

        this.initialTrophies = [];

        var trophyIcon: Phaser.Sprite;

        for (let i = 0; i < 9; i++) {

            trophyIcon = new Phaser.Sprite(this.game, TrophyIconsContainer.PX_ICONS[i], 840 + 106 * (1 - GameVars.scaleY), "texture_atlas_2");
            trophyIcon.scale.y = GameVars.scaleY;
            trophyIcon.name = "" + i;

            trophyIcon.frameName = "trofeo000" + i;
            this.initialTrophies.push(trophyIcon);
            this.add(trophyIcon);
        }
    }

    public init(): void {

        let achievedTrophy = GameVars.getAchievedTrophy();

        let trophyIcon: Phaser.Sprite;

        for (let i = 0; i < 9; i++) {

            trophyIcon = new Phaser.Sprite(this.game, TrophyIconsContainer.PX_ICONS[i], 850 + 106 * (1 - GameVars.scaleY), "texture_atlas_2");

            trophyIcon.name = "" + i;

            // para que sean clickables
            if (i < achievedTrophy) {
                trophyIcon.frameName = "trofeo_off_000" + i;
            } else {
                trophyIcon.frameName = "trofeo000" + i;
            }

            trophyIcon.y = 840 + 106 * (1 - GameVars.scaleY);

            trophyIcon.inputEnabled = true;
            trophyIcon.events.onInputDown.add(this.onClickIcon, this);
            trophyIcon.scale.y = GameVars.scaleY;
            this.add(trophyIcon);

            if (i === achievedTrophy - 1) {

                // poner un trofeo en color por encima con un parpadeo
                let currentTrophyIcon = new Phaser.Sprite(this.game,
                    TrophyIconsContainer.PX_ICONS[i], 838 + 100 * (1 - GameVars.scaleY), "texture_atlas_2", "trofeo000" + i);
                currentTrophyIcon.scale.y = GameVars.scaleY;
                this.add(currentTrophyIcon);

                // poner un tween en alpha de parpadeo sutil
                this.game.add.tween(currentTrophyIcon)
                    .to({ alpha: 0 }, 750, Phaser.Easing.Cubic.Out, true, 0, -1, true);
            }
        }
    }

    public removeIntroTrophies(): void {

        this.initTrophiesIndex = 0;

        for (let i = 0; i < 9; i++) {
            this.game.time.events.add(125 * i, this.removeInitialTrophy, this);
        }

        AudioManager.getInstance().playEffect("quemar_rival");
    }

    private removeInitialTrophy(): void {

        const trophySprite = this.initialTrophies[this.initTrophiesIndex];
        trophySprite.frameName = "trofeo_off_000" + this.initTrophiesIndex;
        trophySprite.y = 850 + 106 * (1 - GameVars.scaleY);
        trophySprite.name = "" + this.initTrophiesIndex;
        trophySprite.inputEnabled = true;
        trophySprite.events.onInputDown.add(this.onClickIcon, this);

        const rndGenerator = new Phaser.RandomDataGenerator([1, 2, 3]);

        const smokeSprite = new Phaser.Sprite(this.game,
            trophySprite.x + trophySprite.width / 2, trophySprite.y + trophySprite.height / 2,
            "texture_atlas_1", "humo_0001");
        smokeSprite.animations.add("burn", Phaser.Animation.generateFrameNames("humo_", 1, 5, "", 4));
        smokeSprite.anchor.set(.5);
        var smokeScale = rndGenerator.between(.65, 1.35);
        smokeSprite.scale.setTo(smokeScale, smokeScale);
        this.add(smokeSprite);
        smokeSprite.play("burn", 16, false, true);

        if (this.initTrophiesIndex === 8) {
            // poner un trofeo en color por encima con un parpadeo
            const currentTrophyIcon = new Phaser.Image(this.game, TrophyIconsContainer.PX_ICONS[8], 838 + 106 * (1 - GameVars.scaleY), "texture_atlas_2", "trofeo0008");
            currentTrophyIcon.scale.y = GameVars.scaleY;
            this.add(currentTrophyIcon);

            // poner un tween en alpha de parpadeo sutil
            this.game.add.tween(currentTrophyIcon)
                .to({ alpha: 0 }, 750, Phaser.Easing.Cubic.Out, true, 0, -1, true);
        }

        this.initTrophiesIndex++;
    }

    private onClickIcon(pSender: any) {

        TrophyState.currentInstance.onClickIcon(+pSender.name);
    }
}
